import { Text, TextStyle } from "pixi.js";
import { CommonResourcesPackage } from "../../../common/resources/CommonResourcesPackage";
import { CheckoutPiggyDescriptionComponent } from "./CheckoutPiggyDescriptionComponent";
import { GameFont } from "../../../common/GameFont";

export class CheckoutPiggyPiggyDescriptionComponent extends CheckoutPiggyDescriptionComponent {
    private static readonly SAVE_TEXT = 'SAVE THEM\n HERE';

    private readonly saveText: Text;

    public constructor(commonResources: CommonResourcesPackage) {
        super(commonResources);
        this.saveText = new Text(CheckoutPiggyPiggyDescriptionComponent.SAVE_TEXT, new SaveTextStyle());
        this.descriptionContent.addChild(this.saveText);
    }
}

class SaveTextStyle extends TextStyle {
    public constructor() {
        super({
            fontFamily: GameFont.DEFAULT_FONT,
            fontSize: 96,
            fill: [
                "#ff4757",
                "#ff2a7f",
                "#ff248a"
            ],
            fillGradientStops: [
                0,
                0.3,
                0.9
            ],
            fillGradientType: 1,
            lineHeight: 82
        });
    }
}